import axios from 'axios';
import { GET_TOP_REVENUE_PRODUCTS, TOP_REVENUE_PRODUCTS_LOADING } from './types';

export const getTopRevenueProducts = () => (dispatch: any) => {
  dispatch({ type: TOP_REVENUE_PRODUCTS_LOADING });
  axios
    .get('/api/admin/getTopRevenueProducts')
    .then((res) => dispatch({ type: GET_TOP_REVENUE_PRODUCTS, payload: res.data }))
    .catch((err) => console.log(err));
};
